<script setup lang="ts">
import Api from "@/services/api/ApiServiceFabrick";
import { ref } from 'vue';
import i18n from '@/lang/i18n';
import CvrUpload from "@/types/CvrUpload";
import ConfirmationModal from "@/components/Common/ConfirmationModal.vue";

const props = defineProps<{
  item: CvrUpload,
  reload: () => void
  showFlash: (message: string, type: string, fadeout: boolean) => void
  updateAuthority: boolean
}>();

const requesting = ref(false);

const confirmationModalTitle = ref("")
const confirmationModalState = ref(false)

function showAlert(error: any) {
  const firstError = (error?.response?.data?.errors?.hold ?? [])[0] ?? '';
  if (firstError == i18n.global.t('pages.cvr_uploads.holdMessages.numberOfHoldingIsOverThresholdDetail')){
    props.showFlash(
      i18n.global.t('pages.cvr_uploads.holdMessages.numberOfHoldingIsOverThreshold'),
      "error",
      false
    );
    return;
  }

  console.log(error)
  props.showFlash(
    i18n.global.t('common.unknownErrorMessage'),
    "error",
    false
  );
}

function showNotification() {
  props.showFlash(
    i18n.global.t('pages.cvr_uploads.holdMessages.successHold'),
    "success",
    true
  );
}

const closeConfirmation = () => {
  hold.value = true;
  confirmationModalState.value = false;
  confirmationModalTitle.value = "";
}

const hold = ref(props?.item?.hold ?? false);

function isVisible() {
  return (props?.item?.status ?? '').toLowerCase() == 'complete' &&
    props?.item?.request_type == 'request';
}

function handleHold(elem) {
  if (hold.value) {
    setHold()
  } else {
    confirmationModalState.value = true;
    confirmationModalTitle.value = i18n.global.t('pages.cvr_uploads.holdMessages.confirmationModalTitle');
  }
}

async function removeHold() {
  requesting.value = true;
  const res = await Api().updateCvrUploadHold(props.item.id, false).catch((error) => {
    console.log(error);
  });
  if (res) {
    props.showFlash(
      i18n.global.t('pages.cvr_uploads.holdMessages.successIgnoreHold'),
      "success",
      true
    );
    props.reload();
  }
  requesting.value = false;
  confirmationModalState.value = false;
}

async function setHold() {
  requesting.value = true;
  const res = await Api().updateCvrUploadHold(props.item.id, true).catch((error) => {
    hold.value = false;
    showAlert(error);
  });
  if (res?.hold === true) showNotification();
  if (res) props.reload();
  requesting.value = false;
}

</script>

<template>
  <div class="change-hold-checkbox" v-if="isVisible()">
    <v-switch
      class="toggle-switch"
      v-model="hold"
      @change="handleHold"
      :readonly="requesting"
      color="success"
      hide-details
      :disabled="!props.updateAuthority"
    ></v-switch>
    <ConfirmationModal
      :title="confirmationModalTitle"
      titleClass="change-hold-checkbox-modal-confirmation-title"
      :modalState="confirmationModalState"
      :confirmBtnName="i18n.global.t('pages.cvr_uploads.holdMessages.confirmationModalBtnLabel')"
      modalMaxWidth="40%"
      @confirm="removeHold"
      @cancel="closeConfirmation"
      :loading="requesting"
    />
  </div>
</template>

<style>
.change-hold-checkbox-modal-confirmation-title {
  font-size: large;
}
</style>

<style scoped>
.toggle-switch {
  width: max-content;
}
.empty_download_column {
  min-width: 140px !important;
  display: block;
}

.collapse {
  background: #DDD;
  overflow: hidden;
  transition: height 200ms;
}

.close {
  height: 0;
}

.open {
  height: 100px;
}
</style>
